import React from "react";

import luxregister from "assets/img/lux-register.png";

function AuthBg(props) {
    return (
        <>

                <img className={"imgRegisterHome"} src={luxregister} />

        </>
    );
}

export default AuthBg;
